<nb-layout>
    <nb-layout-column>
        <nb-card [nbSpinner]="true" nbSpinnerStatus="success">
            <nb-card-body>Autenticando... </nb-card-body>
        </nb-card>
    </nb-layout-column>
</nb-layout>
